<template lang="pug">
    .generic-square-card-control
        .generic-square-card-control__content(:style="contentStyle" @click="click")
            slot
            resize-sensor(@resize="resize")
        .generic-square-card-control__controls
            slot(name="controls")
</template>

<script>
export default {
    name: 'generic-square-card-control',

    data() {
        return {
            size: null,
        }
    },

    computed: {
        contentStyle() {
            return {
                height: `${this.size}px`,
            }
        },
    },

    methods: {
        click() {
            this.$emit('click')
        },

        resize(s) {
            this.size = s.width
        },
    },
}
</script>
